import {CustomEventDefinition} from 'common/report/util/saved-entities/types';

import {BaseClient} from '../utils/base-client';

export class CustomEventsClient extends BaseClient<CustomEventDefinition[]> {
  buildEndpoint({projectId, workspaceId}) {
    if (workspaceId) {
      return `api/app/workspaces/${workspaceId}/custom_events/`;
    }
    return `api/app/projects/${projectId}/custom_events/`;
  }

  processResponse(response) {
    return response.custom_events.map((customEvent) => ({...customEvent, custom: true}));
  }
}

export const customEventsClient = new CustomEventsClient();
